import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathGreaterThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMathGreaterThan"><Path fillRule="evenodd" clipRule="evenodd" d="M5.0394 6.30531C5.147 6.05099 5.44039 5.93205 5.69471 6.03965L18.6947 11.5396C18.8797 11.6179 18.9999 11.7993 18.9999 12.0001C18.9999 12.201 18.8797 12.3823 18.6947 12.4606L5.69471 17.9606C5.44039 18.0682 5.147 17.9493 5.0394 17.695C4.93181 17.4406 5.05075 17.1472 5.30507 17.0396L17.2166 12.0001L5.30507 6.96061C5.05075 6.85302 4.93181 6.55963 5.0394 6.30531Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathGreaterThan;
